import React from 'react'
import { Button, Segment } from 'semantic-ui-react'
import logo from 'img/logo.png'
import '../../style.css'

class RolloverComplete extends React.Component { 
  thisyear = () => this.props.onFinish('/bmc/thisyear')
  future = () => this.props.onFinish('/bmc/future')
  reports = () => this.props.onFinish('/bmc/reports')

  render() {
    return (
      <div className="ui container rollover">
        <Segment>
          <img id='rollLogo' src={logo} alt='logo'/>
          <h1 className='center green'>Your plan has been updated!</h1>
          <h3 className='grey'>If you have not been in for a while this may be a good time to update your account balances and expenses in “This Year”</h3>
          <h3 className='grey'>Select where you would like to go next...</h3>
          <div className='buttons'>
            <Button className='greenOutline' content="This Year" onClick={this.thisyear} />
            <Button className='greenOutline' content="Future Choices" onClick={this.future} />
            <Button className='button_green' content="Choice Assessment" onClick={this.reports} />
          </div>
        </Segment>
      </div>
    )
  }
}

export default RolloverComplete
